import React, { useState } from 'react';
import { Facebook, Instagram, Twitter, Youtube, Phone, Mail } from 'lucide-react';
import { footerLinks, languages } from '../mock';
import oshoLogo from '../assets/osho-logo.png';

const Footer = () => {
  const [lang, setLang] = useState('English');
  const [showLangs, setShowLangs] = useState(false);

  return (
    <footer className="relative bg-rose-deep pt-16 pb-6 text-burgundy">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        {/* Main footer */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 py-14">
          <div>
            <div className="inline-flex items-center bg-white rounded-xl px-4 py-3 mb-6 shadow-sm">
              <img src={oshoLogo} alt="Osho Universal" className="h-12 w-auto" />
            </div>
            <div className="space-y-2 text-burgundy/85">
              <a href="tel:+12143956757" className="flex items-center gap-2 hover:text-mahogany">
                <Phone className="w-4 h-4" /> +1 214 395 6757
              </a>
              <a href="mailto:friendsdesk@oshouniversal.org" className="flex items-center gap-2 hover:text-mahogany">
                <Mail className="w-4 h-4" /> friendsdesk@oshouniversal.org
              </a>
            </div>

            <div className="mt-6">
              <div className="font-serif-display text-mahogany text-xl mb-3">Follow</div>
              <div className="flex gap-3">
                {[Facebook, Instagram, Twitter, Youtube].map((Icon, i) => (
                  <a key={i} href="#" className="w-10 h-10 rounded-full bg-white flex items-center justify-center hover:bg-cream transition-colors">
                    <Icon className="w-4 h-4 text-mahogany" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <FooterColumn title="Quick Links" links={footerLinks.quickLinks} />
          <FooterColumn title="About Us" links={footerLinks.aboutUs} />
          <FooterColumn title="Connect With Us" links={footerLinks.connect} />
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-mahogany/20 flex flex-wrap items-center justify-between gap-4">
          <p className="text-sm text-burgundy/80">copyright © 2026 Osho Universal All Rights Reserved</p>
          <div className="relative">
            <button onClick={() => setShowLangs(!showLangs)} className="flex items-center gap-2 text-sm text-burgundy hover:text-mahogany bg-white/60 rounded-full px-4 py-2">
              🇺🇸 {lang}
            </button>
            {showLangs && (
              <div className="absolute right-0 bottom-full mb-2 w-52 bg-white rounded-xl shadow-lg overflow-hidden z-50">
                {languages.map((l) => (
                  <button
                    key={l}
                    onClick={() => { setLang(l); setShowLangs(false); }}
                    className={`block w-full text-left px-4 py-2 text-sm hover:bg-rose-soft ${l === lang ? 'text-mahogany font-medium' : 'text-burgundy'}`}
                  >
                    {l}
                  </button>
                ))}
              </div>
            )}
          </div>
          <p className="text-sm text-burgundy/80">Designed with love</p>
        </div>
      </div>
    </footer>
  );
};

const FooterColumn = ({ title, links }) => (
  <div>
    <h4 className="font-serif-display text-mahogany text-xl mb-5">{title}</h4>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.name}>
          <a href={l.href} className="text-burgundy/85 hover:text-mahogany transition-colors inline-block relative group">
            {l.name}
            <span className="block h-[1px] w-0 bg-mahogany group-hover:w-full transition-[width] duration-300" />
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
